import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { Button} from 'react-bootstrap'
import { RiDeleteBinLine } from "react-icons/ri";
import { deletUserProfile } from '../../../services/userApiService/userService';
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import swal from "sweetalert";
const DeleteAccountModal = ({ show, handleClose, handleDelete }) => {
const [isDeleting, setIsDeleting] = useState(false);
const handleDeletefun = async () => {
  setIsDeleting(true);
  try {
    const response = await deletUserProfile(); // API call

    if (response?.status === 200) {
      // ✅ Show success message from backend
      swal({
        title: "Success!",
        text: response?.data?.message || "Account deleted successfully.",
        icon: "success",
        buttons: false,
        timer: 2000,
      });

      // ✅ Delay navigation to allow message display
      setTimeout(() => {
        localStorage.removeItem("access_token_admin");
        localStorage.removeItem("login_Details");
        Cookies.remove("access_token_admin");
      Cookies.remove("refresh_token");
        //  window.location.href = process.env.REACT_APP_UK_WEBSITE_URL;
          const userSiteUrl = process.env.REACT_APP_UK_WEBSITE_URL;
           window.location.href = `${userSiteUrl}?clearStorage=true`;
      }, 2000);
    } else {
      // ✅ Handle unexpected success responses
      swal({
        title: "Notice",
        text: response?.data?.message || "Unexpected response.",
        icon: "info",
      });
    }

  } catch (error) {
    console.error("Error deleting account:", error);

    // ✅ Extract error message from backend
    const errorMessage =
      error?.response?.data?.message || "Failed to delete the account.";

    swal({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  } finally {
    setIsDeleting(false);
    handleClose(); // Close the modal
  }
};

 
  return (
    <>
     <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName="custom-modal"
        backdrop="static"
        keyboard={false}
        className='custom-delete-modal'
      >
        <Modal.Body className="text-center p-4">
          <div className="mb-3">
            <RiDeleteBinLine size={40} color="#E63946" />

          </div>
          <h5 className=" mb-4">
            Are You Sure, You Want To <br /> Delete Your Account?
          </h5>

          <div className="d-flex justify-content-center gap-3">
            <Button
              onClick={handleClose}
              className="rounded-pill px-4"
              style={{
                backgroundColor: 'transparent',
                border: '1px solid #6B7280', // custom gray border (you can tweak this)
                color: '#374151',            // dark gray text
              }}
            >
              No, Cancel
            </Button>
            <Button
             className="rounded-pill px-4"
              style={{
                backgroundColor: '#6D28D9',
                borderColor: '#6D28D9',
                color: '#fff',
              }}
            onClick={handleDeletefun}
            >
              Yes, Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default DeleteAccountModal